import 'whatwg-fetch';
import { windowOnLoad } from './js/common';

/* eslint-disable */
const req = require.context('./css/index', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

(() => {
	fetch('static/json/cases.json')
		.then((response) => response.json())
		.then((json) => {
			Array.prototype.forEach.call(json.cases, (caseVal, index) => {
				if (index < 6) {
					// document.querySelector('.window-section.-cases').insertBefore(
					// 	document.querySelector('.case-block:first-child').cloneNode(true),
					// 	document.querySelector('.window-section.-cases > .case-block.-more'),
					// );

					// const caseBlock = document.querySelector(`.case-block:nth-child(${index + 2})`);
					// const caseLink = (() => {
					// 	if (caseVal.link === null) {
					// 		return caseVal.website;
					// 	}

					// 	if (document.body.getAttribute('data-lang') === 'tw') {
					// 		return caseVal.link;
					// 	}

					// 	return `/en${caseVal.link}`;
					// })();

					// caseBlock.setAttribute('href', caseLink);
					// caseBlock.setAttribute('target', caseVal.link === null ? '_blank' : '_self');
					// caseBlock.setAttribute('style', `background-image: url(${caseVal.rectThumb})`);
					// caseBlock.children[0].innerText = caseVal.brand.substring(0, 1);
					// caseBlock.children[1].children[0].innerText = caseVal.brand;
					// caseBlock.children[1].children[1].innerText =
					// 	document.body.getAttribute('data-lang') === 'tw' ?
					// 		caseVal.desc
					// 		:
					// 		caseVal.enDesc;
				}
			});
		});

	/**
	 * switch between two products
	 */
	const productItems = document.querySelectorAll('.products-section .product');
	Array.prototype.forEach.call(productItems, (item) => {
		item.addEventListener('click', (e) => {
			document.querySelector('.products-section').setAttribute(
				'class',
				`products-section ${
					e.currentTarget.classList.contains('-surveycake') ? '-surveycake' : '-backstage'
				}`,
			);
		});
	});
})();

window.onload = () => {
	windowOnLoad();

	/**
	 * variables for scroll
	 */
	let digitalAnimated = false;

	/**
	 * Product section with parallax
	 */
	const productDiv = document.querySelector('.content-section.-features');
	const demoSurveyDiv = document.querySelector('.products-section > .demoimg > .-surveycake');
	const demoBackDiv = document.querySelector('.products-section > .demoimg > .-backstage');
	const parallaxLine = {
		start: productDiv.offsetTop - ((window.innerHeight * 3) / 4),
		end: productDiv.offsetTop + productDiv.offsetHeight,
		demoStart: productDiv.offsetTop - 200,
		demoEnd: productDiv.offsetTop + document.querySelector('.products-section').offsetTop,
		demoOriBtm: document.querySelector('.products-section > .demoimg').offsetHeight - 35,
	};

	/**
	 * change img bottom value to ?px
	 */
	document.querySelector('.products-section > .demoimg > .-surveycake').style.bottom =
		`-${parallaxLine.demoOriBtm}px`;
	document.querySelector('.products-section > .demoimg > .-backstage').style.bottom =
		`-${parallaxLine.demoOriBtm}px`;

	/**
	 * calculate feature ratio to set background-size
	 */
	// productDiv.style.backgroundSize =
	// 	productDiv.offsetWidth / productDiv.offsetHeight > 1280 / 1033 ? '100% auto' : 'auto 100%';

	/**
	 * Logo牆動畫
	 */
	window.addEventListener('scroll', (e) => {
		const currentTop = e.currentTarget.pageYOffset;
		const clientRel = {
			top: document.querySelector('.content-section.-clients').offsetTop - ((window.innerHeight * 1) / 4),
			numInRow:
				Math.floor(
					document.querySelector('.clients-group').offsetWidth / (window.innerWidth > 480 ? 230 : 98),
				),
			animated: false,
		};

		/**
		 * Flip digital card
		 */
		if (digitalAnimated === false && currentTop > (window.innerHeight * 3) / 5) {
			digitalAnimated = true;
			document.querySelector('.digital-intro').className += ' flipInY';
		}

		/**
		 * Parallax in `Features`
		 */
		if (currentTop >= parallaxLine.start && currentTop <= parallaxLine.end) {
			const ratio = (currentTop - parallaxLine.start) / (parallaxLine.end - parallaxLine.start);
			document.querySelector('.content-section.-features')
				.style.backgroundPosition = `${Math.floor(70 * (1 - ratio))}% 50%`;
			document.querySelector('.content-section.-features > .company-name')
				.style.left = `-${Math.floor(850 * ratio)}px`;
		}

		/**
		 * Product demo screen
		 */
		if (currentTop >= parallaxLine.demoStart) {
			/**
			 * Show full demo
			 */
			if (currentTop >= parallaxLine.demoEnd) {
				if (demoSurveyDiv.style.bottom !== '0px') {
					demoSurveyDiv.style.bottom = '0px';
					demoBackDiv.style.bottom = '0px';
				}
			} else {
				const showPercentage = (currentTop - parallaxLine.demoStart) /
					(parallaxLine.demoEnd - parallaxLine.demoStart);
				const btmValue = 0 - Math.floor(parallaxLine.demoOriBtm * (1 - showPercentage));

				document.querySelector('.products-section > .demoimg > .-surveycake').style.bottom = `${btmValue}px`;
				document.querySelector('.products-section > .demoimg > .-backstage').style.bottom = `${btmValue}px`;
			}
		}

		/**
		 * clients block fadeIn
		 */
		if (clientRel.animated === false && currentTop >= clientRel.top) {
			clientRel.animated = true;
			const clientItems = document.querySelectorAll('.clients-group > .client');

			/**
			 * Smart fadeIn JS
			 */
			for (let i = 0; i < Math.ceil(15 / clientRel.numInRow); i += 1) {
				setTimeout(() => {
					for (let j = clientRel.numInRow * i; j < clientRel.numInRow * (i + 1); j += 1) {
						if (clientItems[j]) {
							clientItems[j].className += ' -show';
						}
					}
				}, 500 * i);
			}
		}
	});
};



// WEBPACK FOOTER //
// ./src/app.js